export default "__VITE_ASSET__SHu8$vaZ__"